export const PORTAL_SECTIONS = [
  ['dashboard', 'Pulpit'], ['schedule', 'Harmonogram'], ['billing', 'Rozliczenia'], ['packages', 'Pakiety'],
  ['summaries', 'Tematy zajęć'], ['attendance', 'Frekwencja'], ['history', 'Historia'], ['materials', 'Materiały'],
];

export function portalSearch(section, studentId) {
  const params = new URLSearchParams();
  if (section !== 'dashboard') params.set('section', section);
  if (studentId) params.set('student', studentId);
  return params.toString() ? `?${params.toString()}` : '';
}

export function parsePortalNavigation(search, students) {
  const params = new URLSearchParams(search);
  const section = PORTAL_SECTIONS.some(([id]) => id === params.get('section')) ? params.get('section') : 'dashboard';
  const requested = params.get('student');
  let selectedStudentId = students.some(student => student.id === requested) ? requested : null;
  if (students.length === 1) selectedStudentId = students[0].id;
  return { section, selectedStudentId, normalizedSearch: portalSearch(section, selectedStudentId) };
}
